/// <amd-module name="TFS/CreateProject/Components/FooterContent" />
import * as React from "react";
import { StatusValueType } from "TFS/CreateProject/Contracts";
import * as CreateProjectResources from "TFS/CreateProject/Resources";
import { VssComponent } from "VSS/Platform/Layout";
import { Button } from "VSSUI/Button";
import { ButtonGroup } from "VSSUI/ButtonGroup";

export interface IFooterContentProps {
    pageStatus: StatusValueType;
    onCreateButtonClick: () => void;
    onCancelButtonClick?: () => void;
    isCreateButtonDisabled: boolean;
    isCancelButtonDisabled: boolean;
}

export class FooterContent extends VssComponent<IFooterContentProps, {}> {
    public render(): JSX.Element | null {
        if (this.props.pageStatus === StatusValueType.InProgress) {
            return null;
        }

        return (
            <ButtonGroup className="create-project-actions-container flex flex-noshrink">
                {this.props.onCancelButtonClick && (
                    <span className="cancel-action">
                        <Button
                            disabled={this.props.isCancelButtonDisabled}
                            text={CreateProjectResources.CreateProjectCancelButtonText}
                            onClick={this.props.onCancelButtonClick}
                        />
                    </span>
                )}
                <span className="create-action">
                    <Button
                        className={"create-button"}
                        primary={true}
                        disabled={this.props.isCreateButtonDisabled}
                        text={
                            this.props.onCancelButtonClick
                                ? CreateProjectResources.CreateProjectWithCancelCTAButtonText
                                : CreateProjectResources.CreateProjectCTAButtonText
                        }
                        iconProps={this.props.onCancelButtonClick ? undefined : { iconName: "Add" }}
                        onClick={this.props.onCreateButtonClick}
                    />
                </span>
            </ButtonGroup>
        );
    }
}
